export function mapItemsToDeliveries(order: any) {
  const formattedDeliveries = order.lineItems.reduce((acc: any, item: any) => {
    if (!item.deliveryID) {
      return acc;
    }

    const baseDelivery = order.deliveries.find(
      (delivery: any) => delivery.id === item.deliveryID,
    );

    const existingDelivery = acc.find(
      (delivery: any) => delivery.id === item.deliveryID,
    );

    if (existingDelivery) {
      existingDelivery.items.push(item);
    } else {
      acc.push({
        id: item.deliveryID as string,
        type: baseDelivery?.type as string,
        deliveryFrom: baseDelivery?.deliveryFrom,
        deliveryTo: baseDelivery?.deliveryTo,
        deliveryDate: baseDelivery?.deliveryDate,
        estimatedDeliveryDate: baseDelivery?.estimatedDeliveryDate,
        deliveryAddress: baseDelivery?.deliveryAddress,
        comments: baseDelivery?.comments,
        siloName: baseDelivery?.siloName,
        siloID: baseDelivery?.siloID,
        items: [item],
      });
    }

    return acc;
  }, []);

  return formattedDeliveries;
}
